/**
 * Global audit-log data access (AGENTS.md §2: UI modules must not call
 * supabase.from() directly — writes live in src/lib).
 */
import { supabase } from '../supabase';

/** Minimal fields logGlobalAction reads — structural so any caller user shape passes. */
export type LogUser = { id?: string; name?: string; tenantId?: string | null };

/**
 * Insert one global_logs row. Never throws on failure (the original call-site
 * contract: logging must not break the user action); returns the error for
 * diagnostics.
 */
export async function insertGlobalLog(
  user: LogUser | null | undefined,
  actionType: string,
  details: string,
): Promise<{ error: unknown | null }> {
  if (!user) return { error: null };
  try {
    const activeTenantId = user.tenantId;
    const { error } = await supabase.from('global_logs').insert({
      user_id: user.id || 'unbekannt',
      user_name: user.name || 'Unbekannt',
      action: actionType,
      details: details,
      tenant_id: activeTenantId,
    });
    return { error: error ?? null };
  } catch (e) {
    return { error: e };
  }
}
